import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateTermForm from "../../forms/CreateOrUpdateTermForm";

interface CreateTermModalProps {
  open: boolean;
  onClose: () => void;
  loading: boolean;
  error: string | null;
}

const CreateTermModal: React.FC<CreateTermModalProps> = ({
  open,
  onClose,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title="Create New Term"
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateTermForm loading={loading} error={error} />
  </AppModal>
);

export default CreateTermModal;
